import React, { Component } from 'react';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import EsmsDialog from '../../components/EsmsDialog';
import InputLabel from '@material-ui/core/InputLabel';
import FileUploadInput from '../Global/FileUploadInput';

import classes from './ImportCSVModal.module.css';
import { FormControl } from '@material-ui/core';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as DeviceActions from '../../actions/deviceActions';

class ImportCSVModal extends Component {
    state = {
        fileImport: null,
        fileName:   null
    }

    handleImport = ({ file, fileName }) => {
        this.setState({
            fileImport: file,
            fileName
        });
    };

    handleImportClear = () => {
        this.setState({
            fileImport: null,
            fileName:   null
        });
    }

    handleClose = () => {
        this.props.close();
    }

    handleImportData = async () => {
        const { selectedDevice, stripFileTypeHeader, importFile, close } = this.props;

        const strippedData = stripFileTypeHeader(this.state.fileImport);

        const file = {
            data: strippedData,
            name: this.state.fileName
        };

        await importFile(selectedDevice.id, file);

        close();
    };

    render() {
        const {
            open,
            selectedDevice
        } = this.props;

        if (isEmpty(selectedDevice)) {
            return null;
        }

        return (
            <EsmsDialog
                open={open}
                onClose={this.handleClose}
                title={`Data Import: ${selectedDevice.name}`}
                onConfirm={this.handleImportData}
                confirmText="Import Data"
            >
                <div className={classes.formColumn}>
                    <div className={classes.labelColumn}>
                        <div className={classes.labelHeader}>
                            <img src="/assets/images/uploadIconBlue.svg" alt="upload-icon" className={classes.image} />
                            <span>Import CSV</span>
                        </div>
                        <div className={classes.labelContent}>
                            <p>
                                To import time-series data into a Device you will need to
                                build a CSV file with the top row being the exact names of
                                the Objects as shown in the Devices and Objects screen in
                                the Agent Configuration for the Device you are importing
                                data for. Each Object Name should be seperated by a comma
                                (",").
                            </p>
                            <p>
                                The first Object Name should be <span className={classes.boldText}>DateTime</span> and should be in
                                the following format:
                            </p>
                            <p className={classes.boldText}>
                                m/d/yyyy h:mm
                            </p>
                            <p>
                                Each row should be the value corresponding with the associated
                                top row name, all seperated by a comma (",").
                            </p>
                            <p>
                                Please ensure that all DateTime records are in UTC Time.
                            </p>
                            <p>
                                Note: It may take a few minutes for CSV data to become available.
                            </p>
                        </div>
                    </div>
                    <div className={classes.inputColumn}>
                        <div className={`${classes.inputs} ${classes.customInputs}`}>
                            <div>
                                <InputLabel
                                    htmlFor="file"
                                    classes={{
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }}
                                >
                                    Select a CSV file
                                </InputLabel>
                            </div>
                        </div>
                        <div className={classes.inputs}>
                            <FormControl className={classes.inputWrapper} encType="multipart/form-data">
                                <FileUploadInput
                                    accept=".csv"
                                    upload={this.handleImport}
                                    clear={this.handleImportClear}
                                />
                            </FormControl>
                        </div>
                    </div>
                </div>
            </EsmsDialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedDevice: state.device.selectedDevice
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...DeviceActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportCSVModal);
